import { render } from "./pos.vue?vue&type=template&id=838103e4"
import script from "./pos.vue?vue&type=script&lang=js"
export * from "./pos.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-POP-PROD\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__